<template>
  <v-container fluid class="pa-0 ma-0">
    <v-row class="my-10">
      <AppTitleComponent :title="'Editar perfil'" />
    </v-row>
    <ChatComponent />

    <div class="rounded-pill text-center bg-porcentaje">
      <span class="font-weight-black mx-3">{{ porcentaje }} completado </span
      >{{ paso }}/6 pasos
    </div>

    <v-stepper
      elevation="0"
      v-model="paso"
      v-if="pasos.length > 1"
      alt-labels
      class="mt-5"
    >
      <v-stepper-header style="box-shadow: none">
        <template v-for="(item, i) in pasos">
          <v-stepper-step
            v-if="showStep(item)"
            class="font-weight-bold"
            color="#1C1E4D"
            :complete="paso > item.step"
            :step="item.step"
          >
            {{ item.title }}
          </v-stepper-step>
          <v-divider
            v-if="i !== pasos.length - 1 && showStep(item)"
            :key="i"
          ></v-divider>
        </template>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content
          v-for="(item, i) in pasos"
          :key="i"
          :step="item.step"
        >
          <v-row>
            <v-col>
              <v-card outlined style="border-radius: 10px">
                <v-card-text>
                  <component
                    :is="item.content"
                    :ref="item.ref"
                    v-if="paso == item.step"
                    :ArrayPersona="{ hola: 'holA' }"
                    @actualizar-porcentaje="onActualizarPorcentaje(item.step)"
                  />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col style="justify-content: space-between">
              <center>
                <v-btn
                  @click="anterior"
                  v-if="paso != 1"
                  rounded
                  :class="espacioBotones"
                  outlined
                  style="
                    color: #1c1e4d;
                    background-color: white;
                    border-color: #1c1e4d;
                  "
                >
                  Regresar
                </v-btn>
                <v-btn
                  v-else
                  rounded
                  :class="espacioBotones"
                  outlined
                  @click="regresar()"
                  styles="color: #1C1E4D; background-color: white; border-color: #1C1E4D;"
                >
                  Cancelar
                </v-btn>
                &nbsp;
                <v-btn
                  @click="validar(item.ref)"
                  rounded
                  class="text-capitalize"
                  style="background-color: #1c1e4d; color: white"
                  v-if="paso !== 6"
                >
                  Siguiente
                </v-btn>
                <v-btn
                  @click="goToDetalle()"
                  rounded
                  :class="$vuetify.breakpoint.width <= 398 ? 'mt-4' : 'mt-0'"
                  class="text-none"
                  style="background-color: #1c1e4d; color: white"
                  v-if="esDetalleEmpleo"
                >
                  Continuar con la oferta
                </v-btn>
              </center>
            </v-col>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <!-- <v-row>
        PERSONA: {{ persona }}
    </v-row>
    <v-row>
        {{ datos.dataPaso1 }} {{ datos.dataPaso2 }} {{ datos.dataPaso3 }} {{ datos.dataPaso4 }} {{ datos.dataPaso5 }} {{ datos.dataPaso6 }}dasd
    </v-row> -->
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import AppFooter from "../../components/AppFooter.vue";
import ChatComponent from "../../components/ChatComponent.vue";
import { Paso1, Paso2, Paso3, Paso4, Paso5 } from "../registro/pasos/index";
import expediente from "../expediente/expediente.vue";

export default {
  components: { AppFooter, ChatComponent, expediente },
  name: "indice",
  props: {
    ArrayPersona: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      persona: null,
      pasos: [
        {
          title: "Datos generales",
          content: Paso1,
          step: 1,
          ref: "Paso1",
        },
        {
          title: "Información personal",
          content: Paso2,
          step: 2,
          ref: "Paso2",
        },
        {
          title: "Formación y conocimientos",
          content: Paso3,
          step: 3,
          ref: "Paso3",
        },
        {
          title: "Experiencia laboral",
          content: Paso4,
          step: 4,
          ref: "Paso4",
        },
        {
          title: "Descríbete",
          content: Paso5,
          step: 5,
          ref: "Paso5",
        },
        {
          title: "Documentación complementaria",
          content: expediente,
          step: 6,
          ref: "Paso6",
        },
      ],
      paso: 1,
      datos: {
        dataPaso1: null,
        dataPaso2: null,
        dataPaso3: null,
        dataPaso4: null,
        dataPaso5: null,
        dataPaso6: null,
      },
      porcentaje: null,
    };
  },
  methods: {
    anterior() {
      let paso_anterior = this.paso;
      this.scrollToTop();
      // this.persona = this.datos

      if (paso_anterior == 2) {
        this.paso -= 1;
        this.scrollToTop();
      } else if (paso_anterior == 3) {
        this.paso -= 1;
        this.scrollToTop();
      } else if (paso_anterior == 4) {
        this.paso -= 1;
        this.scrollToTop();
      } else if (paso_anterior == 5) {
        this.paso -= 1;
        this.scrollToTop();
      } else if (paso_anterior == 6) {
        this.paso -= 1;
        this.scrollToTop();
      } else {
        this.paso = 1;
        this.scrollToTop();
      }
    },
    regresar() {
      this.$router.push({ name: "oferta-empleo" });
    },
    async savePaso1(datos) {
      try {
        if (this.isTokenValido(this.token)) {
          const formData = new FormData();
          formData.append("foto", datos.fotoPerfil);
          formData.append("id_estado_civil", datos.estadoFamiliar);
          formData.append(
            "id_municipio_residencia",
            datos.distritoSeleccionado
          );
          formData.append("telefono", datos.numeroTelefono);
          formData.append("segundo_nombre", datos.segundoNombre);
          formData.append("tercer_nombre", datos.tercerNombre);
          formData.append("segundo_apellido", datos.segundoApellido);
          formData.append("apellido_casada", datos.tercerApellido);
          formData.append("id_pais", datos.nacionalidadSeleccionada);
          formData.append("email_personal", datos.emailPersonal)
          const redesMap = {
            facebook: 1,
            linkedin: 2,
            instagram: 3,
            x: 4,
            otro: 5
          };

          const redes_array = Object.entries(datos.redesSociales)
            .filter(([k, v]) => v && v.trim() !== "")
            .map(([key, value]) => ({
              id_tipo_red_social: redesMap[key],
              enlace: value
            }));

          formData.append("redes_sociales", JSON.stringify(redes_array));
          formData.append("no_tiene_redes", datos.noTieneRedes);
          formData.append("justificacion_sin_redes", datos.justificacionSinRedes)

          const response = await this.services.datosPersona.actualizarPersona(
            formData,
            datos.idPersona
          );
          // Verificar la respuesta del servidor
          if (response.status === 201) {
            this.temporalAlert({
              show: true,
              type: "success",
              message: "Persona actualizada con éxito",
            });
            return true; // Indicar que el guardado fue exitoso
          } else {
            throw new Error("Error al actualizar persona");
          }
        } else {
          this.temporalAlert({
            show: true,
            type: "error",
            message: "El token ya expiró, debe volver a iniciar sesión",
          });
          this.$router.replace({ name: "login" });
          return false; // Indicar que hubo un problema con el token
        }
      } catch (err) {
        if (err.response.data.err) {
          const error = err.response.data.err;
          this.temporalAlert({
            show: true,
            type: "error",
            message: `${error.description}`,
          });
          return false;
        }
      }
    },

    async validar(value) {
      if (this.paso === 6) {
        this.pasofinal = true;
        this.scrollToTop();
      } else {
        let ref = this.$refs[value][0];
        if ((await ref.validar_paso()) === true) {
          let datos = await ref.obtener_data();

          switch (this.paso) {
            case 1:
              this.datos.dataPaso1 = datos;
              if (await this.savePaso1(datos)) {
                this.paso = this.paso + 1; // Solo avanzar si el guardado fue exitoso
              }
              this.scrollToTop();
              break;
            case 2:
              this.datos.dataPaso2 = datos;
              this.paso = this.paso + 1;
              this.scrollToTop();
              break;
            case 3:
              this.datos.dataPaso3 = datos;
              this.paso = this.paso + 1;
              this.scrollToTop();
              break;
            case 4:
              this.datos.dataPaso4 = datos;
              this.paso = this.paso + 1;
              this.scrollToTop();
              break;
            case 5:
              this.datos.dataPaso5 = datos;
              this.paso = this.paso + 1;
              this.scrollToTop();
              break;
            case 6:
              this.datos.dataPaso6 = datos;
              this.paso = this.paso + 1;
              this.scrollToTop();
              break;
            default:
              break;
          }
        } else {
          // Lógica para manejar la validación fallida
        }
      }
    },

    showStep(item) {
      if (this.$vuetify.breakpoint.width < 416) {
        return Math.abs(this.paso - item.step) <= 1;
      }
      return true;
    },

    scrollToTop() {
      // Utiliza scrollIntoView o window.scrollTo en el elemento principal que contiene los pasos
      if (this.$refs.currentStep && this.$refs.currentStep.$el) {
        this.$nextTick(() => {
          this.$refs.currentStep.$el.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },

    async getPocentajePerfil() {
      try {
        const response = await this.services.datosPersona.getPorcentajeCompletoPerfil(
          this.idPersona
        );
        this.porcentaje = response.data.porcentaje;
      } catch (e) {
        this.porcentaje = "0%";
      }
    },
    async getPasoPerfil() {
      try {
        const response = await this.services.datosPersona.getPorcentajeCompletoPerfil(
          this.idPersona
        );
        const paso_pendiente = response.data.paso_pendiente;
        if(paso_pendiente == 0){
          this.paso = 1;
        } else {
          this.paso = paso_pendiente;
        }
      } catch (e) {
        this.paso = 1;
      }
    },
    onActualizarPorcentaje(step) {
      if (step === 6) {
        this.getPocentajePerfil();
      }
    },
    goToDetalle() {
      const id = Number(this.$route.query.id || 0);
      this.$router.push("/empleo/" + id);
    },
  },
  computed: {
    ...mapState(["token", "userInfo"]),
    idPersona() {
      return Array.isArray(this.userInfo)
        ? this.userInfo?.[0]?.id_persona || null
        : this.userInfo?.id_persona || null;
    },
    tamañoTitulo() {
      //console.log(this.$vuetify.breakpoint.width);
      if (this.$vuetify.breakpoint.width > 500) {
        return "text-h3 text-bond";
      } else {
        return "text-h4 text-bond";
      }
    },
    tamañoSubtitulo() {
      //console.log(this.$vuetify.breakpoint.width);
      if (this.$vuetify.breakpoint.width > 500) {
        return "text-h5";
      } else {
        return "text-h6";
      }
    },
    espacioBotones() {
      //console.log(this.$vuetify.breakpoint.width);
      if (this.$vuetify.breakpoint.width > 290) {
        return "text-capitalize";
      } else {
        return "mb-5 text-capitalize";
      }
    },
    esDetalleEmpleo() {
      return (
        this.paso === 6 &&
        this.$route.query.from &&
        this.$route.query.from === 'detalle-empleo'
      );
    },
  },
  watch: {
    paso: {
      handler(e) {
        if (e != null) {
          this.getPocentajePerfil()
          /* switch (e) {
              case 1:
                  this.persona = this.dataPaso1
                  break;
              case 2:
                  this.persona = this.dataPaso2
                  break;
              case 3:
                  this.persona = this.dataPaso3
                  break;
              case 4:
                  this.persona = this.dataPaso4
                  break;
              case 5:
                  this.persona = this.dataPaso5
                  break;
              case 6:
                  this.persona = this.dataPaso6
                  break;
              default:
                  break;
          } */
        }
      },
    },
    persona: {
      handler(e) {
        if (e != null) {
          this.paso = this.paso - 1;
        }
      },
    },
    idPersona: {
      immediate: true,
      handler(value) {
        if (value) {
          this.getPocentajePerfil();
          this.getPasoPerfil();
        }
      }
    }
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.bg-porcentaje {
  background-color: #1c1e4d;
  width: fit-content;
  margin: 0 auto;
  padding: 0.8rem 3rem;
  color: #ffffff;
}

.bg-porcentaje span {
  font-size: 18px;
}
</style>
